import { render, staticRenderFns } from "./addinventoryPsi.vue?vue&type=template&id=1d5147d9&scoped=true"
import script from "./addinventoryPsi.vue?vue&type=script&lang=js"
export * from "./addinventoryPsi.vue?vue&type=script&lang=js"
import style0 from "./addinventoryPsi.vue?vue&type=style&index=0&id=1d5147d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5147d9",
  null
  
)

export default component.exports